module.exports = __webpack_public_path__ + "static/media/icon-money.b85ba9ec.svg";